export interface Bonus {
  id: string
  title: string
  value: string
  desc: string
  items: string[]
  itemsLabel: string
  benefit: string
  badgeClass: string
}

export const bonuses: Bonus[] = [
  {
    id: '1',
    title: '100 No-Prep & Emergency Art Lessons',
    value: '15',
    desc: 'A complete library of emergency lessons for schedule changes, substitute days, early finishers, missing materials and last-minute classes.',
    itemsLabel: 'Includes:',
    items: [
      'Drawing',
      'Color',
      'Collage',
      'Painting',
      'Print',
      'Pattern',
      'Texture',
      'Mixed media',
      '3D art',
      'Creative challenges',
    ],
    benefit: 'No preparation needed. Open, choose, teach.',
    badgeClass: 'bg-terracotta text-paper',
  },
  {
    id: '2',
    title: '365 Art Warm-Ups & Creative Starters',
    value: '12',
    desc: 'A complete year of 5–15 minute creative activities, ready to open the class with focus and momentum.',
    itemsLabel: 'Activities for:',
    items: [
      'Line',
      'Shape',
      'Color',
      'Texture',
      'Composition',
      'Creative thinking',
      'Material exploration',
      'Abstract art',
      '3D thinking',
      'Visual response',
    ],
    benefit: 'Never wonder how to start the class again.',
    badgeClass: 'bg-burnt text-paper',
  },
  {
    id: '3',
    title: 'Art Assessment, Rubrics & Student Portfolio Toolkit',
    value: '12',
    desc: 'Professional tools including rubrics, self-assessment, peer critique, portfolio tools and progress tracking.',
    itemsLabel: 'Assess:',
    items: [
      'Idea development',
      'Technique',
      'Material choices',
      'Composition',
      'Experimentation',
      'Craftsmanship',
      'Revision',
      'Presentation',
      'Reflection',
    ],
    benefit: 'Assess artistic progress without grading personal taste.',
    badgeClass: 'bg-sand text-clay border border-warmgray',
  },
  {
    id: '4',
    title: 'Art Classroom Management & Materials Toolkit',
    value: '12',
    desc: 'Practical systems to keep the art room organized before, during and after every session.',
    itemsLabel: 'Systems for:',
    items: [
      'Painting stations',
      'Collage stations',
      'Print stations',
      'Material distribution',
      'Drying work',
      'Project storage',
      'Cleanup',
      'Supply inventory',
      'Classroom workflow',
      'Project preparation',
    ],
    benefit:
      'Spend less time managing materials and more time teaching art.',
    badgeClass: 'bg-clay text-paper',
  },
  {
    id: '5',
    title: '50 Collaborative Art Projects & School Display Ideas',
    value: '12',
    desc: 'Group projects and display systems that turn classroom work into visible school-wide art.',
    itemsLabel: 'Projects for:',
    items: [
      'Murals',
      'Paper installations',
      'Print collaborations',
      'Modular projects',
      'Group sculptures',
      'Recycled-material art',
      'Classroom displays',
      'Hallways',
      'School exhibitions',
    ],
    benefit: 'Have the right collaborative project before class starts.',
    badgeClass: 'bg-terracotta-deep text-paper',
  },
]
